module.exports = __webpack_public_path__ + "static/media/fig_26.5cb4b7ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_26.jpg
// module id = 665
// module chunks = 0